<template>
<div id="ContainerEmployeeList">
       <h4 class="page-title text-truncate">
                {{$t('employeeList.EmplSetupTitle')}}           
        </h4>
  <div class="row">
              <div class="col-sm-12 col-md-3"  v-if="hasPermissionAdd()">                      
                    <MdButton
                      v-bind:Label="$t('employee.Add')" 
                      v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                      v-bind:IconClass="'ti-plus pr-1'"
                      v-on:click="AddEmployee"                   
                      v-bind:Name="'btn_add_Employee'">
                    </MdButton>
                </div>
                <div v-bind:class="hasPermissionAdd() ? 'col-sm-12 col-md-9 mb-4':'col-sm-12 col-md-12 mb-4'">
                    <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                        <div class="input-group" dir="ltr">
                            <input 
                              type="text" 
                              class="form-control"
                              :dir="dirInput"
                              v-model="parameter.SearchCriteria"
                              @keyup.enter="searchListing"
                            >
                            <div class="input-group-append">
                                <div class="input-group-append">
                                <MdButton
                                  v-bind:Name="'btnsearchinput'"
                                  v-bind:VariantProp="'btn btn-sm search-attached'"
                                  v-bind:IconClass="'mdi mdi-magnify'"
                                  v-on:click="searchListing">
                                </MdButton>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

      <div class="row">
        <div class="col-12 mt-2">
        <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
          <div class="row">
            <div class="col-md-12">
              <MdTable 
                v-bind:fields="fields"
                v-bind:items="items"
                v-bind:totalRows="totalRows"
                v-bind:isReadOnly="false"
                v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                v-bind:currentPage="currentPage"
                v-bind:perPage="perPage"
                v-bind:pageOptions="pageOptions"
                :editIconEvent="EditEmployee"
                v-bind:VisibleEditIcon="hasPermissionEdit()"
                :deleteIconEvent="RemoveEmployee"
                v-bind:VisibleDeleteIcon="hasPermissionDelete()"
                :onRowSelected="onRowSelected"
                :onFiltered="onFiltered"
                :pageChanged="pageChanged"
                :perPageFunction="PerPageFunction">
              </MdTable>
            </div>
          </div>
        </div>
      </div>
</div>
</template>

<script>


import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js'
import EmployeeService from '@/services/employee.service'
//import { EventBus } from '../../../event-bus.js';
//import Utils from '@/common/utils'
import Permission from '@/common/Permission'

export default {
    name: 'EmployeeList',
 mixins: [ShowMessage, DBFunctions/*,EventBus*/,Permission],
  data(){
    return{
        OptionsRightMenu:{
          visible:false,
          ItemsList:[],
          btnvisible:false,
          itemdisabled: false,
          PatientCode:'',
          Mode:this.edit_mode,
          favButtonAtion:false          
        },

      //permission: [],
      //Menu : this.$store.state.leftMenu,
      parameter:{
        SearchCriteria:'',
        PageNumber : 0,
        PageSize:0,         
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      ShowMessageIsEmpty:false,
      pageOptions: [5, 10, 15 ],
      items:[],
      fields: [
        { key: 'name', sortable: true, label: this.$t('Shared.Name'), class: 'text-rigth' },     
        { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'text-rigth'}, 
        { key: 'eMail', sortable: true, label: this.$t('Shared.Email'), class: 'text-rigth' },  
        { key: 'employeeType', sortable: true, label: this.$t('Shared.EmployeeType'), class: 'text-rigth' },    
        ],
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',

    }
  },

  methods:{
    searchListing(){
      this.currentPage = 1;
      this.SearchEmployee();
    },

    SearchEmployee(){
       this.$emit('load', true);
      this.parameter.PageNumber = this.currentPage;           
      this.parameter.PageSize = this.perPage;      
      EmployeeService.getAll(this.parameter)
        .then((response) => {
            if(response.status == '200' && response.data){
              this.items = response.data;                        
              this.$emit('load', false);
              let headerString = response.headers["x-pagination"];
              this.totalRows = JSON.parse(headerString).TotalCount;
              }               
        })
        .catch((error) => {                    
            /*if (!error.response) {
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
            }                      
            else if(error.response.status === 400 ){
              this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
            }
            else if(error.response.status === 405 ){             
                  this.$router.push({name: "Main"});    
                    setTimeout(() => 
                        this.showPermissionMessage()
                        , 50);            
            } 
            else if(error.response.status === 500){
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
            } else{
              this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
            } */
            this.$emit('load', false);         
            this.showResponseErrorMessage(error);   
        }); 
    },

    AddEmployee(){
      this.emitDataforFavorites(); 
       this.$router.push({ name: "employee-add"}).catch(()=>{});
    },
    EditEmployee(row){
      this.$router.push({ name: "employee-details", params: { id: row.code } });    
    },
    RemoveEmployee(row){
      const Id = row.code;
           this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$tc('Shared.DelRecord'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
          id: 'modal_delete_Employee'
				})
          .then(value => {
            if(value){
              this.$emit('load', true);  
               EmployeeService.Delete(Id)
                .then(() => {
                  const index = this.items.findIndex(item => item.code === Id) 
                  if (~index) {
                    this.items.splice(index, 1) 
                    this.SearchEmployee(); 
                  }
                })
                .catch((error) => {
                  this.$emit('load', false);  
                    /*if(error.response.status === 400 ){
                     this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }else{
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                     }*/
                    this.showResponseErrorMessage(error);           
                });
            }
          })
    },

    onRowSelected(){

    },

    onFiltered(){

    },
    pageChanged(page){
      this.currentPage = page;    
      this.SearchEmployee();  
    },
    PerPageFunction(perpage){
      this.perPage = perpage;  
      this.currentPage = 1;
      this.SearchEmployee();  
    }
  },

  mounted(){
        this.OptionsRightMenu.ItemsList = [];
       let layoutStatus = this.$store.state.layoutStatus;
       switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }

      this.SearchEmployee();
    
  },

    destroyed(){
      this.OptionsRightMenu.ItemsList = [];
      this.OptionsRightMenu.Mode = false;
      this.OptionsRightMenu.visible = false; 
      this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }
   
};
</script>


